const $ = jQuery.noConflict();

$(document).ready(function () {

  //COOKIE GETTER/SETTER METHODS//
  /**
	 * [setCookie() sets a cookie value that expires after set day(s)]
	 * @param {string} cname  [name of the cookie]
	 * @param {string} cvalue [value to store in the cookie]
	 * @param {int} exdays [number of day(s) when the cookie expires]
	 */
  function setCookie () {

    $.ajax ({
      url: '/api/cookie/set?name=ucla-cookie-policy&val=accepted&min=525600',
      dataType: 'json',
      success: function (data) {

        if (!data.success) {
          console.log('ERROR: there was a problem setting the policy');
        };
      }
    });
  }

  function getCookie () {

    return $.ajax ({
      url: '/api/cookie/get?name=ucla-cookie-policy',
      dataType: 'json'
    });
  }

  getCookie('ucla-cookie-policy').done(function (data) {

    let theCookie = '';

    if (data.success && data.value === 'accepted') {
      theCookie = data.value;
    }

    if (theCookie === '') {
      $('#cookie-policy').css({'display': 'block'});
    } else {
      $('#cookie-policy').remove();
    }

    //set the cookie when the user clicks on the accept button
    $('#cookie-policy-btn').on('click', function () {
      setCookie('ucla-cookie-policy', 'accepted', 365);
      $('#cookie-policy').remove();
    });
  });

});
